import React from 'react';

const Payment = () => {
	return (
		<div>
			<h1>Payment system Coming Soon</h1>
		</div>
	);
};

export default Payment;